import {QUESTION_TRIP, QUESTION_GUIDE,QUESTION_TEXT, QUESTION_TRIP_COUNT, QUESTION_GUIDE_COUNT,ANSWER_USER,QUESTION_TRIP_GUIDE } from "./action";

const initialState = {
    questionTrip : null,
    questionGuide : null,
    questionTripGuide : null,
    questionText:null,
    questionTripCount:null,
    questionGuideCount:null,
    answerUser:null,
}

function questionReducer(state = initialState, action: { type: any; payload: any; }){
    switch (action.type) {
        case QUESTION_TRIP:
            return { ...state, questionTrip: action.payload };
        case QUESTION_TRIP_GUIDE:
            return { ...state, questionTripGuide: action.payload };
        case QUESTION_GUIDE:
            return { ...state, questionGuide: action.payload };
        case QUESTION_TEXT:
            return { ...state, questionText: action.payload };
        case QUESTION_TRIP_COUNT:
            return { ...state, questionTripCount: action.payload };
        case QUESTION_GUIDE_COUNT:
            return { ...state, questionGuideCount: action.payload };
        case ANSWER_USER:
            return { ...state, answerUser: action.payload };
        default:
            return state;
    }
}

export default questionReducer;
